import { Component, OnInit } from '@angular/core';
import { PaymentResultModel } from '../../../model/payment.result.model';
import { ActivatedRoute, ActivationEnd, Router } from '@angular/router';
import { HttpCancelService } from '../../../shared/services/http-cancel.service';
import { TransactionService } from '../../../shared/services/transaction.service';
import { TextService } from '../../../shared/services/text.service';
import { NetmeraService } from "../../../shared/services/netmera-service";
import { Timeout } from "../../../model/netmera-events/timeout";

@Component({
  selector: 'pa-timeout',
  templateUrl: './timeout.component.html',
  styleUrls: ['./timeout.component.scss']
})
export class TimeoutComponent implements OnInit {
  paymentResult: PaymentResultModel;
  deadline = Date.now() + 1000 * 20;
  textService: TextService;
  defaultUrl = 'https://paycell.com.tr/';
  redirectToSiteName: string;

  constructor(private router: Router, private activatedRoute: ActivatedRoute, private transactionService: TransactionService,
              private httpCancelService: HttpCancelService, textService: TextService, private netmeraService: NetmeraService,
              private timeout: Timeout) {
    this.textService = textService;
    this.browserBackButtonBlocking();
    this.activatedRoute.data.subscribe((data: { items: PaymentResultModel }) => {
      this.paymentResult = data.items;
      this.returnUrl(this.paymentResult);
      this.onCancelRequest();
    }, error => {
      this.activatedRoute.params.subscribe(params => {
        this.router.navigate(['/result/error', params.trackingId]);
      })
    });
  }

  ngOnInit(): void {
  }

  onCancelRequest() {
    this.router.events.subscribe(event => {
      if (event instanceof ActivationEnd) {
        this.httpCancelService.cancelPendingRequests()
      }
    });
  }

  returnUrl(paymentResult: PaymentResultModel) {
    if (paymentResult === null || paymentResult.returnUrl === 'undefined' || paymentResult.returnUrl === null) {
      this.redirectToSiteName = this.defaultUrl;
    } else {
      const pattern = new RegExp('^(https?|http)://');
      if (pattern.test(paymentResult.returnUrl)) {
        this.redirectToSiteName = paymentResult.returnUrl;
      } else {
        this.redirectToSiteName = this.defaultUrl;
      }
    }
  }

  stop() {
    this.pushEvent("IslemZamanAsiminaUgradi");
    setTimeout(()=>{
      window.location.href = this.redirectToSiteName ? this.redirectToSiteName : this.defaultUrl;
    }, 2000);
  }

  pushEvent(detay: string) {
    this.netmeraService.pushEvent(this.timeout.setEventObject(detay, this.redirectToSiteName));
  }

  browserBackButtonBlocking() {
    history.pushState(null, null, location.href);
    history.back();
    history.forward();
    window.onpopstate = function () {
      history.go(1);
    };
  }
}
